<template>
  <WebsiteLayout>
    <!--    <template v-slot:mobile-navbar>-->
    <!--      <div-->
    <!--        data-collapse="medium"-->
    <!--        data-animation="over-left"-->
    <!--        data-duration="400"-->
    <!--        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"-->
    <!--        data-easing="ease"-->
    <!--        data-easing2="ease"-->
    <!--        role="banner"-->
    <!--        class="navbar-mobile w-nav"-->
    <!--      >-->
    <!--        <div class="navbar1_container">-->
    <!--          <router-link-->
    <!--            to="/professional-dashboard"-->
    <!--            class="navbar1_logo-link w-nav-brand"-->
    <!--          >-->
    <!--            <img-->
    <!--              src="@/assets/timeslot-images/timeslate-logo.svg"-->
    <!--              loading="lazy"-->
    <!--              alt=""-->
    <!--              class="navbar1_logo"-->
    <!--          /></router-link>-->

    <!--          <div-->
    <!--            @click="showNav"-->
    <!--            class="navbar1_menu-button w-nav-button"-->
    <!--            style="-webkit-user-select: text;"-->
    <!--            aria-label="menu"-->
    <!--            role="button"-->
    <!--            tabindex="0"-->
    <!--            aria-controls="w-nav-overlay-0"-->
    <!--            aria-haspopup="menu"-->
    <!--            aria-expanded="false"-->
    <!--          >-->
    <!--            <div class="menu-icon1">-->
    <!--              <div class="menu-icon1_line-top"></div>-->
    <!--              <div class="menu-icon1_line-middle">-->
    <!--                <div class="menu-icon_line-middle-inner"></div>-->
    <!--              </div>-->
    <!--              <div class="menu-icon1_line-bottom"></div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div-->
    <!--          v-if="cross"-->
    <!--          class="w-nav-overlay"-->
    <!--          data-wf-ignore=""-->
    <!--          id="w-nav-overlay-0"-->
    <!--          style="height: 100vh; display: block; width: 100%;"-->
    <!--        >-->
    <!--          <nav-->
    <!--            role="navigation"-->
    <!--            class="navbar1_menu w-nav-menu"-->
    <!--            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"-->
    <!--            data-nav-menu-open=""-->
    <!--          >-->
    <!--            <div class="div-block-4-copy top">-->
    <!--              <div-->
    <!--                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"-->
    <!--                class="link-block-3 w-inline-block"-->
    <!--                @click="closeNav"-->
    <!--              >-->
    <!--                <img-->
    <!--                  src="@/assets/timeslot-images/cancel.svg"-->
    <!--                  loading="lazy"-->
    <!--                  alt=""-->
    <!--                />-->
    <!--              </div>-->
    <!--              <div class="div-block-51">-->
    <!--                <div class="div-block-5-copy">-->
    <!--                  <div class="div-block-6-copy">-->
    <!--                    <div class="text-block-8">-->
    <!--                      {{ userInfo.customerFirstName.charAt(0)-->
    <!--                      }}{{ userInfo.customerLastName.charAt(0) }}-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                  <div class="div-block-28">-->
    <!--                    <div class="text-block-6">-->
    <!--                      {{ userInfo.customerFirstName }}-->
    <!--                      {{ userInfo.customerLastName }}-->
    <!--                    </div>-->
    <!--                    <div class="text-block-7">-->
    <!--                      <a @click="goToProfile" class="link-18">View profile</a>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div class="div-block-29">-->
    <!--                  <router-link-->
    <!--                    to="/professional-dashboard"-->
    <!--                    aria-current="page"-->
    <!--                    class="link-block-4 dashboard w-inline-block w&#45;&#45;current"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Dashboard</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-messages"-->
    <!--                    class="link-block-4 message w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Messages</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-bookings"-->
    <!--                    class="link-block-4 booking w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Bookings</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-subscriptions"-->
    <!--                    class="link-block-4 feeds w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Subscriptions</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-wallet"-->
    <!--                    class="link-block-4 wallet w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Wallet</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-settings"-->
    <!--                    class="link-block-4 settings w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Settings</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-notifications"-->
    <!--                    class="link-block-4 discover w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Notifications</div>-->
    <!--                  </router-link>-->
    <!--                </div>-->
    <!--                <div class="div-block-29-copy">-->
    <!--                  <router-link-->
    <!--                    to="/discover-professionals"-->
    <!--                    class="link-block-4 conection w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Discover</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-support"-->
    <!--                    class="link-block-4 support w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Support</div>-->
    <!--                  </router-link>-->
    <!--                  <a-->
    <!--                    @click="logout"-->
    <!--                    class="link-block-4 log-out w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Log out</div>-->
    <!--                  </a>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div></div>-->
    <!--          </nav>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </template>-->
    <div class="app-container hero">
      <div class="main-app-wrapper dashboard">
        <div class="div-block-56">
          <div class="div-block-57">
            <div class="text-block-49">Discover</div>
            <div class="text-block-50">
              Explore and discover professionals of your choice
            </div>
          </div>
          <div class="filter-wrapper">
            <div class="div-block-166">
              <form action="/search" class="search-3 w-form">
                <input
                  type="search"
                  class="search-input-4 w-input"
                  maxlength="256"
                  name="query"
                  placeholder="Search…"
                  id="search-2"
                  v-model="searchModel.stringToFind"
                  @input="searchProfessionalAction"
                />
                <input
                  type="submit"
                  value="Search"
                  class="search-button-3 w-button"
                />
              </form>
            </div>
            <div class="div-block-58">
              <div class="s-width">
                <FormulateInput
                  type="select"
                  name="professionalCategory"
                  placeholder="Expertise"
                  :options="categoryList"
                  input-class="select-field"
                  v-model="searchModel.expertise"
                  @input="searchProfessionalAction"
                />
              </div>

              <div class="s-width">
                <FormulateInput
                  type="select"
                  name="professionalExperienceLevel"
                  :options="experienceLevels"
                  input-class="select-field"
                  placeholder="Level"
                  v-model="searchModel.level"
                  @input="searchProfessionalAction"
                />
              </div>

              <div class="s-width">
                <FormulateInput
                  type="select"
                  name="country"
                  validation-name="Country"
                  placeholder="Country"
                  :options="countries"
                  v-model="searchModel.country"
                  @input="searchProfessionalAction"
                />
              </div>
            </div>
          </div>
          <BaseComponentLoader
            v-if="loader.nonBlockingLoader"
            loaderAlignment="center"
          />
          <div
            class="div-block-59"
            v-if="professionalDiscover.length > 0 && !loader.nonBlockingLoader"
          >
            <!--            <div-->
            <!--              id="w-node-_5ae59988-b252-43c7-257a-66703dd36a96-8f09cdd5"-->
            <!--              class="professional-card-wrapper"-->
            <!--              v-for="(professional, index) in professionalDiscover"-->
            <!--              :key="index"-->
            <!--            >-->
            <!--              <a-->
            <!--                @click="profile(professional)"-->
            <!--                class="professional_cards w-inline-block"-->
            <!--              >-->
            <!--                <div class="div-block-16">-->
            <!--                  <div class="text-block-16">-->
            <!--                    {{ professional.customerName }}-->
            <!--                  </div>-->
            <!--                  <div class="text-block-17">-->
            <!--                    {{ professional.professionalSubCategory }}-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </a>-->
            <!--              <a href="" class="link-block-2 w-inline-block"></a>-->
            <!--            </div>-->
            <div
              class="ejzqWn"
              v-for="(professional, index) in professionalDiscover"
              :key="index"
              @click="profile(professional)"
            >
              <img
                class="ejzqWn"
                :src="
                  professional.customerDisplayPicture ||
                    'https://apvertise-repo.s3.amazonaws.com/logo23470493927891664919183983.jpeg'
                "
              />
              <div class="overlay">
                <div class="details">
                  <p class=" text-block-16">{{ professional.customerName }}</p>
                  <div class="details__items">
                    <div class=" text-block-17">
                      <span>{{ professional.professionalSubCategory }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="div-block-199"
                v-if="professional.professionalBookingFee === 0"
              >
                <div class="text-block-108">⚡Free</div>
              </div>
            </div>
          </div>
          <div
            class="prof-empty"
            v-if="
              professionalDiscover.length === 0 && !loader.nonBlockingLoader
            "
          >
            There are no professionals under this category
          </div>
          <div
            class="div-block-60"
            v-if="showMoreValue && !loader.nonBlockingLoader"
          >
            <div class="button-13 w-button" @click="moreProfessionals">
              Load more professionals
            </div>
          </div>
        </div>
      </div>
    </div>
  </WebsiteLayout>
</template>

<script>
import WebsiteLayout from "@/components/layout/WebsiteLayout";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import { countryCodes } from "@/utils/country/countryCodes";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";

export default {
  name: "Discover",
  components: { WebsiteLayout, BaseComponentLoader },
  data() {
    return {
      bar: true,
      cross: false,
      expertise: false,
      level: false,
      country: false,
      searchValue: "",
      professionalExpertise: "",
      professionalLevel: "",
      professionalCountry: "",
      searchModel: ProfessionalRequest.search,
      searchItem: null,
      showMoreValue: true
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalId: state => state.professional.professionalId,
      professionalList: state => state.professional.professionals,
      professionalDiscover: state => state.professional.professionalsDisplay,
      categories() {
        return StoreUtils.rootGetters(
          StoreUtils.getters.professional.GET_CATEGORIES
        );
      },
      categoryList() {
        return Object.keys(this.categories);
      },
      experienceLevels() {
        return StoreUtils.rootGetters(
          StoreUtils.getters.professional.GET_EXPERIENCE_LEVELS
        );
      },
      countries() {
        return countryCodes.map(data => {
          return { label: data.name, value: data.name };
        });
      },
      loader: state => state.loader
      // showMore(){
      //   let show = true;
      //   let currentTotal = this.professionalDiscover.length;
      //   let previousTotal = (this.searchModel.page - 1) * 8;
      //   let properTotal = (this.searchModel.page) * 8;
      //   if(currentTotal >= previousTotal && currentTotal <= properTotal){
      //      return show = true;
      //   }
      //   else{
      //     return show = false;
      //   }
      // }
    })
  },
  methods: {
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/professionals/${this.professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    toggleExpertise() {
      this.expertise = !this.expertise;
    },
    toggleLevel() {
      this.level = !this.level;
    },
    toggleCountry() {
      this.country = !this.country;
    },
    profile(professional) {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL,
        professional
      );
      StoreUtils.commit(
        "professional/updateProfessionalId",
        professional.professionalId
      );
      RouterUtils.changeRouteUrlTo(
        `/professionals/${professional.professionalId}`
      );
    },

    searchProfessionalAction() {
      StoreUtils.dispatch("professional/searchProfessional", this.searchModel);
    },
    moreProfessionals() {
      this.searchModel.page = this.searchModel.page + 1;
      StoreUtils.dispatch("professional/searchProfessional", this.searchModel);
    }
  },
  watch: {
    "searchModel.page"(newValue) {
      if (
        newValue * 8 <= this.professionalDiscover.length &&
        (newValue - 1) * 8 < this.professionalDiscover.length
      ) {
        this.showMoreValue = false;
      } else {
        this.showMoreValue = true;
      }
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.READ_PROFESSIONALS);
    StoreUtils.dispatch(StoreUtils.actions.professional.FETCH_CATEGORIES);
    StoreUtils.dispatch(
      StoreUtils.actions.professional.FETCH_EXPERIENCE_LEVELS
    );
  }
};
</script>

<style scoped>
.s-width {
  width: 20%;
}
.prof-empty {
  text-align: center;
  margin-top: 50px;
}
.ejzqWn {
  width: 100%;
  height: 269px;
  display: block;
  overflow: hidden;
  position: relative;
  border-radius: 16px;
  text-decoration: none;
  border: 0.5px solid rgba(105, 105, 105, 0.6);
  cursor: pointer;
}
.ejzqWn:hover,
.ejzqWn:active {
  transform: scale(1.05);
}
.ejzqWn .overlay {
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px 24px;
  position: absolute;
  flex-direction: column;
  transition: all 0.25s ease 0s;
  background-image: linear-gradient(transparent 0%, rgba(0, 0, 0, 0.5));
}
.ejzqWn .top-items {
  display: grid;
  grid-auto-flow: column;
  gap: 6px;
}
.ejzqWn .top-items .favorited {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.dwCcQI .favorited,
.dwCcQI .details__items .item:nth-child(2) {
  display: none !important;
}
.ejzqWn .details {
  margin-top: auto;
  color: rgb(255, 255, 255);
}

.ejzqWn .details p {
  margin-bottom: 0px;
}
.ejzqWn .details__name {
  font-weight: 700;
  line-height: 18px;
}

.ejzqWn .details__items {
  /*margin-top: 10px;*/
}

.ejzqWn .details__items .item:first-child {
  margin-top: 0px;
}
.ejzqWn .details__items .item {
  display: flex;
  font-size: 14px;
  margin-top: 4px;
  line-height: 1.6;
}
@media only screen and (max-width: 991px) {
  .s-width {
    width: 50%;
  }
  .div-block-58 {
    gap: 10px;
  }
}
</style>
